import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { UserService } from '../services/user.service';
import * as Security from '../tokens/roles.tokens';

@Injectable()
export class UnitAdminGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkLoggedIn(state.url);
  }

  private checkLoggedIn(url: string): boolean {
    if (
      this.userService.isLoggedIn() &&
      this.userService.userHasRole([Security.ApplicationRoles.byuiLeader])
    ) {
      // this.router.navigate(['/unit-management']);
      return true;
    }
    this.router.navigate(['/unit-login'], { queryParams: {returnUrl: url }});
    return false;
  }
}
